export default __webpack_public_path__ + "static/media/bars.def20dc4.svg";